import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyA_wZ5yiZN6Md1rNaM7oi7vEeuzvaT6itQ",
  authDomain: "pepeganet-a13db.firebaseapp.com",
  databaseURL: "https://pepeganet-a13db-default-rtdb.firebaseio.com",
  projectId: "pepeganet-a13db",
  storageBucket: "pepeganet-a13db.appspot.com",
  messagingSenderId: "796169496285",
  appId: "1:796169496285:web:6974fc9bb256b973f65d34",
  measurementId: "G-FG87X5DZ5D"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();

export const db = getFirestore(app);